import countriesData from "../../../../constants/countries.json";

export const FORM_ID = "sf-shipping-form";

export const COUNTRY_OPTIONS = countriesData.map((c) => ({
  value: c.isoCode,
  label: c.name,
}));

const SHIPPING_FORM = {
  DEFAULT_COUNTRY: "US",
  LABELS: {
    BACK: "Return to Details",
    CONTINUE: "Continue",
    TITLE: "Shipping Address",
    SUBTITLE: "Please enter the destination details for this device.",
    ORDER_SUMMARY: "Order Summary",
    SUBTOTAL: "Subtotal",
    SHIPPING: "Shipping",
    TAXES: "Taxes",
    TOTAL: "Total",
    CALCULATED: "Calculated next step",
  },
  FIELDS: {
    FULL_NAME: {
      name: "fullName",
      label: "Full Name",
      placeholder: "Jane Doe",
    },
    PHONE: {
      name: "phoneNumber",
      label: "Phone Number",
      placeholder: "+1 (555) 000-0000",
    },
    EMAIL: {
      name: "email",
      label: "Email Address",
      placeholder: "jane@enterprise.com",
    },
    ADDRESS_1: {
      name: "addressLine1",
      label: "Address Line 1",
      placeholder: "123 Corporate Blvd",
    },
    ADDRESS_2: {
      name: "addressLine2",
      label: "Address Line 2 (Optional)",
      placeholder: "Suite 400",
    },
    CITY: { name: "city", label: "City", placeholder: "San Francisco" },
    STATE: {
      name: "state",
      label: "State / Province",
      placeholder: "CA",
    },
    COUNTRY: {
      name: "country",
      label: "Country",
      placeholder: "Select country",
    },
    POSTAL: {
      name: "postalCode",
      label: "Postal Code",
      placeholder: "94105",
    },
  },
  ERRORS: {
    FULL_NAME: "Full name is required",
    PHONE: "Phone number is required",
    EMAIL_REQUIRED: "Email is required",
    EMAIL_FORMAT: "Enter a valid email",
    ADDRESS: "Address is required",
    CITY: "City is required",
    STATE: "State is required",
    COUNTRY: "Country is required",
    POSTAL: "Postal code is required",
  },
} as const;

export default SHIPPING_FORM;
